<template>
  <v-container>
    <v-row class="mt-3" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card>
          <v-card-text>
            <h3 class="text-center">
              You will need an account to access the data
            </h3>
            <!-- Request access -->
            <v-row class="mt-2">
              <v-col class="text-center">
                <v-btn to="/request-access" color="accent"
                  >Request access</v-btn
                >
              </v-col>
            </v-row>

            <!-- or -->
            <v-row class="mt-3">
              <v-col class="text-center">
                <hr />
                <span class="or-span">or</span>
              </v-col>
            </v-row>

            <!-- Sign in -->
            <template v-if="!$store.state.resetPasswordForm">
              <h3 class="text-center">
                Sign in if you already have an account
              </h3>

              <v-row class="mt-3">
                <v-col>
                  <login-form></login-form>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <small class="text-center reset-password-text"
                    >Have you forgotten your password?
                    <span @click="$store.state.resetPasswordForm = true"
                      >Click here to reset it.</span
                    ></small
                  >
                </v-col>
              </v-row>
            </template>

            <!-- Reset password -->
            <template v-else>
              <h3 class="text-center">
                Enter your email to reset your password
              </h3>

              <v-row class="mt-3">
                <v-col>
                  <reset-password-form></reset-password-form>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <small class="text-center reset-password-text"
                    >Are you not looking to reset your password?
                    <span @click="$store.state.resetPasswordForm = false"
                      >Click here to return to the login form.</span
                    ></small
                  >
                </v-col>
              </v-row>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.or-span {
  position: relative;
  top: -13px;
  background-color: white;
  padding: 8px;
}

.reset-password-text {
  font-size: 90%;
}

.reset-password-text span:hover {
  text-decoration: underline;
}

.reset-password-text span {
  cursor: pointer;
}
</style>

<script>
import LoginForm from "./LoginForm";
import ResetPasswordForm from "./ResetPasswordForm";

export default {
  components: {
    LoginForm,
    ResetPasswordForm
  }
};
</script>
